export const SIZES = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  AUTO: 'auto'
}

export const DECORATIVE_IMAGE_ALT = ''
